import { Button, Chip, List, ListItem, ListItemButton, styled } from '@mui/material'
import { TreeItem, TreeView } from '@mui/x-tree-view'

export const BorderSideNav = styled(props => {
  return <List component="nav" {...props} />
})(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  paddingTop: '8px',
  paddingBottom: '16px',
  maxWidth: 240,
  display: 'flex',
  flexWrap: 'wrap',
  '&.admin': {
    borderTop: `1px solid ${theme.palette.grey[100]}`
  },
  [theme.breakpoints.down('xs')]: {
    maxWidth: '100%',
    width: '100%'
  }
}))

export const ItemClearFilter = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  '&.client': {
    color: theme.palette.warning.main
  },
  '&.admin': {
    color: theme.palette.common.white
  }
}))

export const ChipLine = styled(Chip)(({ theme }) => ({
  width: 5,
  height: 5,
  margin: 10,
  '&.client': {
    backgroundColor: theme.palette.primary.light
  },
  '&.admin': {
    backgroundColor: theme.palette.secondary.light
  }
}))

export const ButtonClearFilters = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  maxHeight: 29,
  padding: '4px 8px !important',
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 500,
  '&.client': {
    backgroundColor: theme.palette.warning.light
  }
}))

export const FamilyItemButton = styled(ListItemButton)(({ theme }) => ({
  margin: '8px 16px',
  borderRadius: 8,
  height: 104,
  width: '100%',
  padding: 16,
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[700],
  '& h6': {
    fontWeight: 500
  },
  '&.aesthetic': {
    background: 'radial-gradient(100% 190.76% at 0% 100%, #ED7E2D 0%, #D83F2D 100%)'
  },
  '&.cosmetic': {
    background: 'radial-gradient(100% 190.76% at 0% 100%, #ED7E2D 0%, #D83F2D 100%)'
  },
  '&.appliance': {
    background: 'radial-gradient(100% 190.76% at 0% 100%, #3089AB 0%, #313E82 100%)'
  },
  '&.specialized-aesthetics': {
    background: 'radial-gradient(100% 279.07% at 0% 4.03%, #2E22AC 0%, #DA499C 100%)'
  },
  '&.depilation': {
    background: 'radial-gradient(107.12% 320.04% at 100% 119.02%, #C290C5 0%, #363E7D 100%)'
  },
  '&.hands-nails-feet': {
    background: 'radial-gradient(105.34% 183.33% at 2.86% 114.79%, #E19047 1.34%, #D3CA9E 100%)'
  },
  '&.small': {
    height: 32
  }
}))

export const StyledTreeView = styled(TreeView)(({ theme }) => ({
  '& .Mui-expanded': {
    borderLeft: '4px solid',
    borderColor: theme.palette.secondary.main
  },
  '& .MuiTypography-root': {
    fontSize: '15px',
    fontWeight: 400
  }
}))

export const StyledTreeItem = styled(TreeItem)(({ theme }) => ({
  '&.admin': {
    '&.MuiTreeItem-root:hover': {
      background: theme.palette.grey[700],
      '& .MuiTypography-root': {
        color: theme.palette.grey[50]
      }
    },
    '& .Mui-expanded': {
      background: theme.palette.grey[700]
    },
    '& .MuiTypography-root': {
      color: theme.palette.grey[300]
    },
    '& .MuiTreeItem-iconContainer > svg': {
      color: theme.palette.grey[200],
      fontSize: '30px'
    }
  },
  '&.client ': {
    ' &.MuiTreeItem-root:hover': {
      background: 'white',
      '& .MuiTypography-root': {
        color: theme.palette.grey[700]
      }
    },
    '& .Mui-expanded': {
      background: theme.palette.grey[100]
    },
    '& .MuiTypography-root': {
      color: theme.palette.grey[700]
    },
    '& .MuiTreeItem-iconContainer > svg': {
      color: theme.palette.grey[600],
      fontSize: '30px'
    }
  },
  '& .MuiTreeItem-content': {
    height: 28,
    paddingLeft: 24,
    width: 'calc(100% - 24px)',
    [theme.breakpoints.up('md')]: {
      height: 28,
      paddingLeft: 8,
      width: 'calc(100% - 8px)'
    },
    [theme.breakpoints.down('xs')]: {
      height: 48,
      '& p': {
        fontSize: '16px'
      }
    }
  }
}))

export const LineTreeItem = styled(TreeItem)(({ theme }) => ({
  '&.MuiTreeItem-root:hover': {
    background: '#E3E5E8',
    '& .MuiTypography-root': {
      color: theme.palette.grey[50]
    }
  },
  '& .MuiTreeItem-root': {
    height: 28,
    display: 'flex',
    '&.client:hover > .MuiTreeItem-content': {
      backgroundColor: theme.palette.grey[100]
    },
    '& .MuiTreeItem-iconContainer > svg': {
      color: theme.palette.secondary.main
    },
    [theme.breakpoints.down('xs')]: {
      height: 32,
      '& p': {
        fontSize: '16px'
      }
    }
  },
  '& .Mui-selected': {
    borderLeft: '4px solid',
    borderColor: theme.palette.secondary.main,
    '& > .MuiTreeItem-content': {
      marginLeft: '-4px'
    },
    '&.client': {
      backgroundColor: theme.palette.grey[100]
    },
    '&.admin': {
      backgroundColor: theme.palette.grey[700]
    }
  },
  '.MuiTreeItem-label': {
    backgroundColor: 'transparent'
  }
}))
